/**
 * Link target for "see / choose a plan" from inside the app.
 *
 * Plain `/welcome` redirects every signed-in role-holder to `/dashboard`; the
 * `browse-plans` intent keeps them on the plan list (`resolveWelcomeRedirect`).
 * Signed-out visitors see the same plan list either way.
 */
export const BROWSE_PLANS_PATH = '/welcome?intent=browse-plans';
